import React from "react";
import { routes } from "../../utils/utils.routes";
import { ModernBreadcrumb } from "./ModernBreadcrumb";
import { isTenderContent } from "../../utils/tenders";

const categoryHref = (category: string, type?: string) => {
  const c = (category || "").toLowerCase();
  if (isTenderContent({ type, category })) return routes.TENDERS;
  if (c === "event" || c === "evenement") return routes.EVENTS;
  if (c === "activity" || c === "activite") return `${routes.ARTICLES}/activite`;
  if (c === "article") return routes.ARTICLES;
  return routes.ARTICLES;
};

const categoryLabel = (category: string, type?: string) => {
  if (isTenderContent({ type, category })) return "Appels d'offres";
  if (category === "event" || category === "evenement") return "Événements";
  if (category === "activity" || category === "activite") return "Activités";
  return category || "Actualités";
};

export const BreadcrumbArticle: React.FC<{
  category: string;
  post_title: string;
  type?: string;
}> = ({ category, post_title, type }) => (
  <ModernBreadcrumb
    items={[
      { label: "Accueil", href: routes.HOME },
      { label: categoryLabel(category, type), href: categoryHref(category, type) },
      { label: post_title },
    ]}
  />
);
